export const snackbarHandler = (requestStatus, actionLabel, message) => {
  let variant = requestStatus === 'fulfilled' ? 'success' : 'error';
  let fullMessage = `${actionLabel} ${
    message ? message : variant === 'success' ? 'successful' : 'failed'
  }`;
  return { variant: variant, message: fullMessage };
};
